// nav.js
// Mobile nav drawer: hamburger toggle, focus management, Escape to close,
// keyboard focus trap, and body scroll lock.
// Also marks the current-page nav link with aria-current="page".

function setActiveNav() {
  const currentPath = window.location.pathname;
  document.querySelectorAll('.site-header__link').forEach(link => {
    if (link.pathname === currentPath) {
      link.setAttribute('aria-current', 'page');
    }
  });
}

function initNav() {
  const toggle = document.querySelector('.site-header__toggle');
  const drawer = document.querySelector('.nav-drawer');
  const closeBtn = document.querySelector('.nav-drawer__close');
  const drawerLinks = drawer?.querySelectorAll('a[href]') || [];

  if (!toggle || !drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn?.focus();
  }

  function closeDrawer({ restoreFocus = true } = {}) {
    drawer.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (restoreFocus) toggle.focus();
  }

  toggle.addEventListener('click', () => {
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => closeDrawer());
  }

  drawerLinks.forEach(link => {
    link.addEventListener('click', () => closeDrawer({ restoreFocus: false }));
  });

  document.addEventListener('keydown', (event) => {
    if (!drawer.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (event.key === 'Tab') {
      const focusable = Array.from(
        drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      );
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  setActiveNav();
}

export default initNav;
